var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmHeatMapLM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-heat-map-dm-cls-1 {\n        fill: #e54040;\n      }\n\n      .dummy-widget-heat-map-dm-cls-1, .dummy-widget-heat-map-dm-cls-2, .dummy-widget-heat-map-dm-cls-3, .dummy-widget-heat-map-dm-cls-4, .dummy-widget-heat-map-dm-cls-5, .dummy-widget-heat-map-dm-cls-6, .dummy-widget-heat-map-dm-cls-7, .dummy-widget-heat-map-dm-cls-8, .dummy-widget-heat-map-dm-cls-9, .dummy-widget-heat-map-dm-cls-10 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-heat-map-dm-cls-1, .dummy-widget-heat-map-dm-cls-4, .dummy-widget-heat-map-dm-cls-6, .dummy-widget-heat-map-dm-cls-10 {\n        isolation: isolate;\n      }\n\n      .dummy-widget-heat-map-dm-cls-1, .dummy-widget-heat-map-dm-cls-4, .dummy-widget-heat-map-dm-cls-10 {\n        opacity: .7;\n      }\n\n      .dummy-widget-heat-map-dm-cls-2 {\n        fill: #c1c1c1;\n      }\n\n      .dummy-widget-heat-map-dm-cls-11 {\n        clip-path: url(#dummy-widget-heat-map-dm-clippath);\n      }\n\n      .dummy-widget-heat-map-dm-cls-3 {\n        fill: none;\n      }\n\n      .dummy-widget-heat-map-dm-cls-4 {\n        fill: #65b563;\n      }\n\n      .dummy-widget-heat-map-dm-cls-5 {\n        fill: #e9e9ea;\n      }\n\n      .dummy-widget-heat-map-dm-cls-6 {\n        opacity: .5;\n      }\n\n      .dummy-widget-heat-map-dm-cls-6, .dummy-widget-heat-map-dm-cls-8 {\n        fill: #fff;\n      }\n\n      .dummy-widget-heat-map-dm-cls-7 {\n        fill: #f4f3f3;\n      }\n\n      .dummy-widget-heat-map-dm-cls-9 {\n        fill: #dadada;\n      }\n\n      .dummy-widget-heat-map-dm-cls-10 {\n        fill: #eedd3b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-heat-map-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-3",
    x: 7.5,
    y: 7.5,
    width: 155.1,
    height: 153.7
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-5",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-heat-map-dm-cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-dm-cls-8",
    d: "M13.9,33.1h142.1c3.4,0,6.2,2.8,6.2,6.2v90.2c0,3.4-2.8,6.2-6.2,6.2H13.9c-3.4,0-6.2-2.8-6.2-6.2V39.3c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-dm-cls-2",
    d: "M155.4,136H14.6c-3.9,0-7.1-3.2-7.1-7.1V40c0-3.9,3.2-7.1,7.1-7.1h140.8c3.9,0,7.1,3.2,7.1,7.1v88.9c0,3.9-3.2,7.1-7.1,7.1h0ZM14.6,33.3c-3.7,0-6.7,3-6.7,6.7v88.9c0,3.7,3,6.7,6.7,6.7h140.8c3.7,0,6.7-3,6.7-6.7V40c0-3.7-3-6.7-6.7-6.7H14.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-dm-cls-6",
    d: "M14.2-82.1h142.1c3.5,0,6.3,2.8,6.3,6.2V13.9c0,3.4-2.8,6.2-6.3,6.2H14.2c-3.5,0-6.3-2.8-6.3-6.2v-89.8c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-dm-cls-6",
    d: "M14.2,148.6h142.2c3.5,0,6.3,2.8,6.3,6.2v86.3c0,3.4-2.8,6.2-6.3,6.2H14.2c-3.5,0-6.3-2.8-6.3-6.2v-86.3c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-7",
    x: 15.5,
    y: 40.9,
    width: 138.5,
    height: 86.8,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-9",
    x: 15.5,
    y: 96.4,
    width: 138.5,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 26.7,
    y: 40.9,
    width: 5.5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 55.5,
    y: 40.9,
    width: 5.5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 70.4,
    y: 40.9,
    width: 5.5,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 99.6,
    y: 110.8,
    width: 5.5,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 127.4,
    y: 40.9,
    width: 5.5,
    height: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 56.3,
    y: 69.8,
    width: 33.7,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 27.1,
    y: 110.8,
    width: 33.7,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 84.3,
    y: 40.9,
    width: 5.5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 113,
    y: 40.9,
    width: 5.5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 141.8,
    y: 40.9,
    width: 5.5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 26.7,
    y: 103.6,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 55.5,
    y: 103.6,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 84.3,
    y: 103.6,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 113,
    y: 103.6,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-dm-cls-8",
    x: 141.8,
    y: 103.6,
    width: 5.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 35.2,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 39.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 48.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 49.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 50.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 52.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 63.5,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 67.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 83,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 61.3,
    cy: 93.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 61.3,
    cy: 82.5,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 53.7,
    cy: 108.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 26.5,
    cy: 65.2,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 83,
    cy: 67.3,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 83,
    cy: 64.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 112.4,
    cy: 85.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 123.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 124.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 127.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-10",
    cx: 55.9,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-10",
    cx: 62.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-1",
    cx: 59.1,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-4",
    cx: 115.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-10",
    cx: 117.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-dm-cls-1",
    cx: 120,
    cy: 99.9,
    r: 3.9
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmHeatMapLM);
export default __webpack_public_path__ + "static/media/dm_heat_map_l-m.5f44aaa8.svg";
export { ForwardRef as ReactComponent };